import { jsx as _jsx } from "react/jsx-runtime";
import { useAemConfig } from '@as-react/common-components';
import { isProduct } from '@as-react/common-types';
import { HtmlInclude, ScriptTypes } from '../../components/common/html-include/HtmlInclude';
import { getProductDetailUrl } from '../../util/ProductUtil';
import { useProductListerContext } from './context';
const AMOUNT_PRODUCTS_DATA = 20;
const generateProductsSchema = (products, root, origin) => {
    return {
        '@context': 'https://schema.org',
        '@type': 'ItemList',
        itemListElement: products.map((product, index) => ({
            '@type': 'ListItem',
            position: String(index + 1),
            item: {
                '@type': 'Product',
                productID: product.productCode,
                name: product.title,
                description: product.description,
                brand: {
                    name: product.brand,
                    '@type': 'http://schema.org/Organization',
                    '@context': 'http://schema.org/',
                },
                url: `${origin}${product.seoUrl ? getProductDetailUrl(product, root) : ''}`,
            },
        })),
    };
};
export const ProductListerJsonLd = () => {
    var _a;
    const { canonicalUrl, root } = useAemConfig();
    const { query: { data: products }, } = useProductListerContext();
    const listerProducts = ((_a = products === null || products === void 0 ? void 0 : products.items) === null || _a === void 0 ? void 0 : _a.filter(item => isProduct(item)).slice(0, AMOUNT_PRODUCTS_DATA)) || [];
    const { origin } = new URL(canonicalUrl);
    const productsSchema = generateProductsSchema(listerProducts, root, origin);
    return _jsx(HtmlInclude, { scriptFragment: JSON.stringify(productsSchema, null, 2), scriptType: ScriptTypes.LD_JSON });
};
